import { blrfOperations } from 'app/state/ducks/blrf';

const { clear } = blrfOperations;

const get = ( key, id ) => ( dispatch ) => {

    dispatch ( blrfOperations.get( {
        endpoint: 'admin/realm',
        key,
        id
    }) );
    
};

const getTypes = ( key ) => ( dispatch ) => {

    dispatch( blrfOperations.get( {
        endpoint: 'admin/realm/types',
        key
    }) );

};

const update = ( key, id, data ) => async ( dispatch ) => {

    return await dispatch ( blrfOperations.update( {
        endpoint: `admin/realm/${id}`,
        key,
        data
    }) );

};

const create = ( key, data ) => async ( dispatch ) => {

    return await dispatch ( blrfOperations.create( {
        endpoint: 'admin/realm',
        key,
        data
    }) );

};

const search = ( key, data ) => ( dispatch ) => {

    return dispatch ( blrfOperations.search( {
        endpoint: 'admin/realm/search',
        key, 
        data
    }) );

};

const remove = ( key, id ) => async ( dispatch ) => {

    return await dispatch ( blrfOperations.remove( {
        endpoint: `admin/realm/${id}`,
        key
    }) );

};

export {
    get, 
    getTypes,
    create,
    update, 
    search,
    remove,
    clear
};
